module.exports = __webpack_public_path__ + "img/cloud4.f6ccdd3a.svg";